import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase/config';
import CoverPhoto from './CoverPhoto';
import StatsGrid from './StatsGrid';
import VenuesWidget from './VenuesWidget';

export default function HomeTab({ user, bandId, bandData, setActiveTab, isPremium }) {
  const [stats, setStats] = useState({
    totalSongs: 0,
    totalVersions: 0,
    totalGigs: 0,
    upcomingGigs: 0,
    totalDocuments: 0
  });
  const [photoTransform, setPhotoTransform] = useState(null);

  // Fetch all band data and calculate stats
  useEffect(() => {
    if (!user || !bandId) return;

    const bandsRef = ref(database, `bands/${bandId}`);
    
    const unsubscribe = onValue(bandsRef, (snapshot) => {
      if (!snapshot.exists()) return;
      
      const bandFullData = snapshot.val();
      
      // Load saved photo transform (new) or convert legacy position
      if (bandFullData.bandDocs?.bandPhotoTransform) {
        setPhotoTransform(bandFullData.bandDocs.bandPhotoTransform);
      } else if (bandFullData.bandDocs?.bandPhotoPosition !== undefined) {
        // Legacy: convert old Y-only position to new transform format
        setPhotoTransform({ x: 50, y: bandFullData.bandDocs.bandPhotoPosition, zoom: 1 });
      }
      
      // Calculate songs stats
      const songs = bandFullData.songs || {};
      const songsArray = Object.keys(songs);
      let totalVersions = 0;
      
      songsArray.forEach(songId => {
        const song = songs[songId];
        if (song.versions) {
          totalVersions += Object.keys(song.versions).length;
        }
      });
      
      // Calculate gigs stats
      const gigs = bandFullData.gigs || {};
      const gigsArray = Object.keys(gigs).map(id => ({ id, ...gigs[id] }));
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const upcomingGigs = gigsArray.filter(gig => new Date(gig.date) >= today);
      
      // Calculate documents stats
      const docs = bandFullData.bandDocs || {};
      let docCount = 0;
      if (docs.bandPhoto) docCount++;
      if (docs.bioSmall) docCount++;
      if (docs.bioMedium) docCount++;
      if (docs.bioLarge) docCount++;
      if (docs.rider) docCount += Object.keys(docs.rider).length;
      if (docs.gearList) docCount += Object.keys(docs.gearList).length;
      if (docs.livePhotos) docCount += Object.keys(docs.livePhotos).length;
      
      setStats({
        totalSongs: songsArray.length,
        totalVersions,
        totalGigs: gigsArray.length,
        upcomingGigs: upcomingGigs.length,
        totalDocuments: docCount
      });
    });

    return () => unsubscribe();
  }, [user, bandId]);

  return (
    <div className="space-y-6">
      <CoverPhoto 
        user={user} 
        bandId={bandId} 
        bandData={bandData} 
        photoTransform={photoTransform} 
      />

      <StatsGrid 
        stats={stats} 
        bandData={bandData} 
        setActiveTab={setActiveTab} 
        isPremium={isPremium} 
      />

      <VenuesWidget 
        user={user} 
        bandId={bandId} 
        setActiveTab={setActiveTab} 
        isPremium={isPremium} 
      />
    </div>
  );
}
